import { compose, withProps } from 'recompose';
import { withLabel } from '@/se/components/Label';
import ReportRecipients from '../../sensor/ReportRecipients';
import SelectInput from '@/se/components/inputs/SelectInput';
import ObjectInput from '@/se/components/inputs/ObjectInput';
import { hoursOptions } from '@/util/timeOptions';

const OrScheduleConfigInput = withProps({
  schema: {
    dailyReportRecipients: compose(
      withLabel('Daily report recipients'),
      withProps({ name: 'dailyReportRecipients', showChannelBadges: true })
    )(ReportRecipients),
    reportHour: compose(
      withLabel(
        'Fallback report hour',
        {},
        'The report is sent automatically when the last patient leaves the OR. If the last patient has not been discharged by this hour (e.g. due to delayed data entry), the report will be sent at this time instead.'
      ),
      withProps({ name: 'reportHour', options: hoursOptions })
    )(SelectInput),
  },
})(ObjectInput);

export default OrScheduleConfigInput;
